// import axios from 'axios';
// import { API_URL } from '../constants/constants';

// export const loginUser = async (dispatch, credentials) => {
//   try {
//     const res = await axios.post(`${API_URL}/login`, credentials);
//     dispatch({
//       type: 'LOGIN_SUCCESS',
//       payload: { user: res.data.user, token: res.data.token },
//     });
//     return res.data;
//   } catch (err) {
//     console.error('Login error:', err);
//     alert('Invalid credentials');
//     return null;
//   }
// };


import api from '../api';

/* =========================
   LOGIN WITH PASSWORD
   username OR email

   UI-polish pass: this used to swallow its own error with a native
   `alert()` and return null, so Login.js's `lp-error` banner (added when
   the login page was redesigned) never received a real message -- callers
   saw an ugly browser alert AND a generic "Login failed" fallback
   underneath it. Now it just throws so the caller's own try/catch (which
   already reads err?.response?.data?.message) is the single source of
   error UI.
========================= */
export const loginUser = async (dispatch, credentials) => {
  const res = await api.post(`/login`, credentials);

  dispatch({
    type: 'LOGIN_SUCCESS',
    payload: {
      user: res.data.user,
      token: res.data.token,
      expires_at: res.data.expires_at,
    },
  });

  return res.data;
};

/* =========================
   SEND OTP ON EMAIL
========================= */
export const sendLoginOtp = async (email) => {
  const res = await api.post(`/login/send-otp`, {
    email,
  });

  return res.data;
};

/* =========================
   VERIFY OTP AND LOGIN
========================= */
export const verifyLoginOtp = async (dispatch, payload) => {
  const res = await api.post(`/login/verify-otp`, payload);

  dispatch({
    type: 'LOGIN_SUCCESS',
    payload: {
      user: res.data.user,
      token: res.data.token,
      expires_at: res.data.expires_at,
    },
  });

  return res.data;
};